import { required, transformToUrl } from 'helpers/utils';
import { websiteWithLines } from 'helpers/regexp';

export const validateQueryString = (value: string) => {
  const requiredError = required(value);
  if (requiredError) return requiredError;
  const processedValue = transformToUrl(value);
  if (!websiteWithLines.test(processedValue) || processedValue.endsWith('-')) {
    return 'This field has incorrect characters.';
  }
  return undefined;
};
